import { LitElement, html, css } from 'lit';

class OrangeButtonLink extends LitElement {
  static properties = {
    href: { type: String, reflect: true },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  static styles = css`
    .orange-button {
      text-align: center;
      font-weight: normal;
      font-size: 16px;
      line-height: 150%;
      background-color: #d76315;
      padding: 16px 24px;
      box-shadow: 0px 4px 0px #95440E;
      border-radius: 1000px;
      color: #ffffff;
      border-width: 0px;
      cursor: pointer;
      justify-content: center;
      display: inline-flex;
      max-width: 392px;
      text-decoration: none;
      text-align: start;
      &:hover {
        opacity: 0.8;
        text-decoration: none;
        color: #ffffff;
      }
    }
    a.orange-button {
      color: #ffffff;
    }
  `;
  render() {
    return html`
      <a href="${this.href}" class="orange-button">
        <slot></slot>
      </a>
    `;
  }
}

if (!customElements.get('orange-button-link')) {
  customElements.define('orange-button-link', OrangeButtonLink);
}